import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { GSM_ERROR_NAME } from '@app/shared/gsm/gsm-ui-lib-ng-shared/src/lib/gsm-error';
import { GsmErrorService } from '@app/shared/gsm/gsm-ui-lib-ng-shared/src/lib/gsm-error.service';
import { RouterService } from '@app/shared/services/router.service';
import { LowLevelApi } from '@app/shared/services/state/low-level-api.service';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { GsmEnabledGuard } from './gsm-enabled.guard';
import { GsmVersionCompatibilityGuard } from './gsm-version-compatibility.guard';
import { GsmAuthGuard } from './gsm.auth.guard';
import { SyncHelperGuard } from './sync-helper.guard';

@Injectable({
  providedIn: 'root'
})
export class GsmGuard extends SyncHelperGuard {
  private readonly llapi = inject(LowLevelApi);
  private readonly routerService = inject(RouterService);
  private readonly errorService = inject(GsmErrorService);

  protected syncGuards = [
    GsmEnabledGuard,
    GsmAuthGuard,
    GsmVersionCompatibilityGuard
  ];

  constructor() {
    super();
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return super.canActivate(route, state)
      .pipe(
        switchMap((canActivate: boolean) => {
          if (canActivate === false) {
            this._finalizeCannotActivate();
          }
          return of(canActivate);
        }),
        catchError((error) => {
          this._finalizeCannotActivate();
          if (error.name === GSM_ERROR_NAME) {
            this.errorService.catchError(error);
          }
          return of(false);
        })
      );
  }

  private _finalizeCannotActivate() {
    this.llapi.patchValue('layout.spinner', false);
    this.routerService.routeRoot();
  }
}
